import moment from 'moment';

export default function getSeason() {
    const fall = [1, 8, 9, 10, 11, 12];
    const month = parseInt((moment().format('M')));
    const season = (fall.includes(month)) ? 'fall' : 'spring';
    return season;
}